<template lang="html">
	<div class="base-errors" v-if="errors.length > 0" :style="errorsStyle">
		<span>Что-то пошло не так:</span>
		<div class="error" v-for="error in errors">
			<div class="error-info">{{error}}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['errors', 'errorsStyle']
}
</script>

<style scoped="" lang="css">
.base-errors {
	color: red;
	word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Manager/Shared/BaseErrors.vue